import { render, staticRenderFns } from "./37.vue?vue&type=template&id=2b861998&scoped=true&"
import script from "./37.vue?vue&type=script&lang=js&"
export * from "./37.vue?vue&type=script&lang=js&"
import style0 from "./37.vue?vue&type=style&index=0&id=2b861998&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b861998",
  null
  
)

export default component.exports